import React, { useState, useEffect } from "react";
import Main from "../../components/Main";
import TabelaDinamica from "../../components/TabelaDinamica";
import MensagemErro from "../../components/MensagemErro";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import CRUDPageHeader from "../../components/CRUDPageHeader";
import { obterFolhas, obterFolhasCompleto, obterFolhasPorTexto } from "../../services/api-esocial.service";
import ExportExcelButton from "../../components/ExportExcelButton";
import { Grid } from "@mui/material";
import styles from "./styles.module.css";
import { simplifyString } from "../../utils/simplify_string";

const Folhas = () => {
  const [data, setData] = useState([]);
  const [grupoECnpj, setGrupoECnpj] = useState({})
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const columns = [
    { id: "periodoApurado", label: "Período de\nApuração", field: "periodoApurado_cellval" },
    { id: "idTabelaRubrica", label: "ID da Tabela\nde Rubricas", field: "idTabelaRubrica" },
    { id: "codRubrica", label: "Código de\nRubrica", field: "codRubrica_cellVal" },
    { id: "descricaoRubrica", label: "Descrição", field: "descricaoRubrica" },
    { id: "tipoRubrica", label: "Tipo de\nRubrica", field: "tipoRubrica" },
    { id: "valorRubrica", label: "Valor da\nRubrica", field: "valorRubrica_cellVal", type: 'monetario' },
    { id: "incidencia", label: "Incidência", field: "incidencia_cellVal" },
    { id: "composicaoProjeto", label: "Composição\nde Projeto", field: "composicaoProjeto" },
  ];

  const handleTratarDados = (cnpj, dados) => {
    let dadosTratados = dados.map(item => {
      return {
        ...item,
        periodoApurado_cellval: `${item.periodoApurado.split('-')[1]}/${item.periodoApurado.split('-')[0]}`,
        codRubrica_cellVal: simplifyString(item.codRubrica),
        tipoRubrica: item.tipoRubrica,
        valorRubrica: Number(item.valorRubrica),
        valorRubrica_cellVal: item.valorRubrica ? item.valorRubrica : ' ',
        incidencia_cellVal: item.incidencia ? item.incidencia : '-',
        terceiros: item.terceiros ? `${item.terceiros} %` : ' ',
        rat: item.rat ? `${item.rat} %` : ' ',
        inss: item.inss ? `${item.inss} %` : ' ',
        selic: item.selic ? `${item.selic} %` : ' ',
      }
    });
    
    const currentDate = new Date();
    const startDate = new Date(currentDate.getFullYear() - 5, currentDate.getMonth() - 1, 1);

    console.log(`start: ${startDate}`);
    console.log(`current: ${currentDate}`);
    
    dadosTratados = dadosTratados.filter((obj) => {
        const [year, month] = obj.periodoApurado.split('-').map(Number);
        const objDate = new Date(year, month - 1);
        return objDate >= startDate && objDate <= currentDate;
    });

    setData(dadosTratados);
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await obterFolhas(grupoECnpj.CNPJ);
        handleTratarDados(grupoECnpj.CNPJ, response.folha);
        setLoading(false)
      } catch (err) {
        if (err.response) {
          setMsg(err.response.data.mensagem);
          handleOpenSnackbarErro();
        } else {
          setMsg("Erro: Tente novamente!");
          handleOpenSnackbarErro();
        }
        setLoading(false)
      }
    };

    if (grupoECnpj.CNPJ) {
      fetchData();
    } else {
      setData([]);
    }
  }, [grupoECnpj]);

  const getExportFilename = (cnpj) => {
    return "folha_esocial_idEmpresa_"
      .concat(cnpj)
      .concat("_")
      .concat(
        new Date()
          .toISOString()
          .replace(/\.\d{3}/, "")
          .replace("T", " ")
          .replace("Z", "")
          .replaceAll(":", "-")
          .replace(" ", "_")
      );
  };

  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const handleGrupoECnpjChange = (ids) => {
    setGrupoECnpj(ids)
  }

  const handleDebounceChange = async (event) => {
    setLoading(true)
    if (grupoECnpj.CNPJ) {
      try {
        const response = await obterFolhasPorTexto(grupoECnpj.CNPJ, event.target.value)
        handleTratarDados(grupoECnpj.CNPJ, response.folha)
      } catch (err) {
        if (err.response) {
          setMsg(err.response.data.mensagem);
          handleOpenSnackbarErro();
        } else {
          console.log(err);

          setMsg("Erro: Tente novamente!");
          handleOpenSnackbarErro();
        }
      }
    } else {
      setMsg('Necessário selecionar uma Empresa.');
      handleOpenSnackbarErro();
    }
    setLoading(false);
  }

  const obtainFolhasCompleto = async () => {
    try {
      const response = await obterFolhasCompleto(grupoECnpj.CNPJ);
      const folhaData = await setupExportDataCompleto(response.folha);
      const fileName = await getExportFilename(grupoECnpj.CNPJ);
      return [ folhaData, fileName ];
    } catch (err) {
      if (err.response) {
        setMsg(err.response.data.mensagem);
        handleOpenSnackbarErro();
      } else {
        setMsg("Erro: Tente novamente!");
        handleOpenSnackbarErro();
      }
      setLoading(false)
    }
  }

  const setupExportDataCompleto = (eventosFolha) => {
    let exportDataCompleto = [];
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const startDate = new Date(currentYear - 5, currentMonth - 2);

    eventosFolha.forEach((folha) => {
      const folhaDate = new Date(folha.ano, folha.mes - 1);

      if (folhaDate >= startDate && folhaDate <= currentDate) {
        exportDataCompleto.push({
          "<style bold>Empresa</style>": folha.razao_social,
          "<style bold>CNPJ</style>": folha.cnpj,
          "<style bold>Ano</style>": folha.ano,
          "<style bold>Mês</style>": folha.mes,
          "<style bold>Código de Rubrica</style>": folha.codigo_rubrica,
          "<style bold>Descrição da Rubrica</style>": folha.descricao_rubrica,
          "<style bold>Válido De</style>": (folha.valido_de) ? folha.valido_de : '',
          "<style bold>Válido Até</style>": (folha.valido_ate) ? folha.valido_ate : '',
          "<style bold>Tipo de Rubrica</style>": folha.tipo_rubrica,
          "<style bold>Valor da Rubrica</style>": Number(folha.valor_rubrica),
          "<style bold>Incidência</style>": (folha.incidencia) ? folha.incidencia : '',
          "<style bold>Composição de Projeto</style>": folha.composicao_projeto
        });
      }
    });
    return exportDataCompleto;
  }

return (
  <div>
    <Main />

    <CRUDPageHeader
      headerIcon={<>
        <RequestPageIcon fontSize="30px"/>
      </>}
      headerTitle="Folha eSocial"
      disableModalButton
      handleDebounceChange={handleDebounceChange}
      AutoCompleteRequired={grupoECnpj.CNPJ ? false : true}
      AutoCompleteGrupoECnpj
      handleGrupoECnpjChange={handleGrupoECnpjChange}
    />

    <TabelaDinamica
      data={data}
      columns={columns}
      loading={loading}
      extraProps={
        <Grid item xs={2} className={styles.buttonPadding}>
          <ExportExcelButton
            buttonLabel={'Download'}
            retrieveData={obtainFolhasCompleto}
          />
        </Grid>
      }
      disableDelete
      disableEdit
    />

    <MensagemErro
      open={openSnackbarErro}
      handleClose={handleCloseSnackbarErro}
      msg={msg}
    />
  </div>
);
};


export default Folhas;
